import { ModificationType as t } from "@ancon/wildcat-types";
function o(i) {
  const n = [];
  return i.selectedIngredients.forEach((e) => {
    e.selected ? e.replacementId && n.push({
      modification: t.Replace,
      ingredientId: e.id,
      replaceId: e.replacementId
    }) : n.push({
      modification: t.Remove,
      ingredientId: e.id
    });
  }), i.selectedAddons.forEach((e) => {
    if (e.selectedIngredientId) {
      n.push({
        addOnGroupId: e.addonId,
        modification: t.Add,
        ingredientId: e.selectedIngredientId,
        quantity: 1,
        freeAmount: e.ingredients.some((d) => d.freeAmount === 1) ? 1 : 0
      });
      return;
    }
    e.ingredients.forEach((d) => {
      d.selectedCount && n.push({
        addOnGroupId: e.addonId,
        modification: t.Add,
        ingredientId: d.id,
        quantity: d.selectedCount,
        freeAmount: d.freeAmount
      });
    });
  }), {
    modifications: n,
    quantity: i.quantity,
    variantId: i.selectedVariantId,
    showingPrice: i.selectedVariantShowingPrice
  };
}
export {
  o as default
};
